import { select } from 'redux-saga/effects'

export const selectUserOrgId = () => select((state) => state.user.org_id)
